import { Pipe, PipeTransform } from '@angular/core';
import { MediaVariantPipe } from './media-variant.pipe';
import { FileRecordDto } from '@careapp-group/ng-sdk-v2-new';

@Pipe({
  name: 'videoIsReady',
  pure: true,
})
export class VideoIsReadyPipe implements PipeTransform {
  transform(value: FileRecordDto): boolean {
    const variantPipe = new MediaVariantPipe();
    return !!(
      variantPipe.transform(value, 'purpose', 'videoThumbnail') &&
      variantPipe.transform(value, 'mimeType', 'video/mp4')
    );
  }
}
